module.exports = __webpack_public_path__ + "static/img/img-servicios-arl.d24fb88.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Seguros-arl/img-servicios-arl.png
// module id = Q/LS
// module chunks = 0